import { SignatureStatus } from '@/common/utils/signatureStatus'

type SignedDocument = {
  time: string,
  status: SignatureStatus,
  mySignature: {
    time: string,
    status: SignatureStatus,
  },
  otherSignatures: Array<{ status: SignatureStatus }>
}

export function statusDataMap (signedDocument: SignedDocument): SignatureStatus | null {
  const { status, mySignature, otherSignatures } = signedDocument

  if (status === SignatureStatus.Sent && mySignature.status === SignatureStatus.Sent) {
    return SignatureStatus.Sent
  }

  if (status === SignatureStatus.Sent && mySignature.status === SignatureStatus.Signed) {
    return SignatureStatus.Signed
  }

  if (status === SignatureStatus.Signed && !mySignature && otherSignatures.every(o => o.status === SignatureStatus.Signed)) {
    return SignatureStatus.SignedByAll
  }

  if (status === SignatureStatus.Signed && mySignature.status === SignatureStatus.Signed) {
    return SignatureStatus.SignedByAll
  }

  if (status === SignatureStatus.Voided) {
    return SignatureStatus.Voided
  }

  return null
}

export function dateDataMap (signedDocument: SignedDocument): string | null  {
  const status = statusDataMap(signedDocument)
  const { time, mySignature } = signedDocument

  if (!status) {
    return null
  }

  if (status === SignatureStatus.Sent) {
    return mySignature.time
  } else if (status === SignatureStatus.Signed && mySignature.time) {
    return mySignature.time
  } else if (status === SignatureStatus.SignedByAll) {
    return time
  } else if (status === SignatureStatus.Voided) {
    return time
  }

  return null
}
